import {createSelector} from 'reselect';
import _ from 'lodash';

export const confirmationContentSelector = state => state.confirmation.content;

export const customerConfirmationInfoSelector = createSelector(
  confirmationContentSelector,
  content => _.get(content, 'customerInfo.customerInfo', [])
);

export const customerNameEmailSelector = createSelector(
  customerConfirmationInfoSelector,
  customer => ({
    firstName: _.get(customer, 'firstName', ''),
    emailAddress: _.get(customer, 'emailAddress', '')
  })
);

export const cartInfoSelector = createSelector(
    confirmationContentSelector,
    content => _.get(content, 'cartInfo', {})
);

export const showWatchNowSelector = createSelector(
    confirmationContentSelector,
    content => _.get(content, 'tVEGoEnableWatchNow', false)
);

export const equipmentAddedSelector = createSelector(
  cartInfoSelector,
  cart => _.get(cart, 'equipmentAdded', {})
);

export const showShippingInfoSelector = createSelector(
  equipmentAddedSelector,
  equipment => !_.isEmpty(equipment)
);



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/confirmation/selectors.js
 **/